import React from 'react';
// import ReactDOM from 'react-dom';
import GongqiFormItem from './GongqiFormItem';
import CommandResolver from '../utils/CommandResolver';
import CommandTask from '../forms/sys/remote/CommandTask';
import TreeRefreshArg from '../forms/sys/remote/TreeRefreshArg';
import Cmd from '../forms/sys/remote/Cmd';
import {CommandMapEditorsStore} from '../stores/CommandStore';
import {RefreshPluginStore} from '../stores/CmdTypeStore';
import {FocusSetStore} from '../stores/FocusStore';
import FocusActions from '../actions/FocusActions';
require('../styles/FormItemPluginStyle.css')
export default class FormItemPluginTree extends GongqiFormItem
{

	constructor(props)
	{
		super(props);
		this.unsubscribeCommandMapEditorsStore = CommandMapEditorsStore.listen(this.onMapEditorsHandler.bind(this));
		this.unsubscribeRefreshPluginStore = RefreshPluginStore.listen(this.onRefresh.bind(this));
		this.unsubscribeFocusSetStore = FocusSetStore.listen(this.onFocusSet.bind(this));
	}

	onFocusSet(formId,itemId,pre,init)
	{
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			$(this.pluginTreeContainer).focus();
		}
	}

	componentWillUnmount()
	{
		this.unsubscribeCommandMapEditorsStore();
		this.unsubscribeRefreshPluginStore();
	}

	componentDidMount()
	{
		$(this.treeDiv).height($(this.treeDiv).parent().height()-12);
		

		let key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
		if(window.hasOwnProperty(key))
		{
			let pluginLaterArg = window[key];
			let tasks = pluginLaterArg.tasks;
			for(let i = 0;i<tasks.length;i++)
			{
				this.refresh(tasks[i]);
			}
			window[key] = null;
			delete window[key];
		}
		
		//$(this.treeDiv).css("width",$(this.treeDiv).width()+"px");
		//$(this.treeDiv).css("height",$(this.treeDiv).height()+"px");
		//alert("height:"+$(this.treeDiv).css("height"));
		//alert("width:"+$(this.treeDiv).css("width"));
		// var setting = {
		// 	data: 
		// 	{
		// 		key: {
		// 			title:"t"
		// 		},
		// 		simpleData: {
		// 			enable: true
		// 		}
		// 	},
		// 	callback:
		// 	{
		// 		// beforeClick: this.beforeItemClick.bind(this),
		// 		// onClick: this.onItemClick.bind(this),
		// 		onDblClick: this.onItemDblClick.bind(this),
		// 		onRightClick: this.onItemRightClick.bind(this)
		// 	}
		// };
		
		// var xmlStr='<node>'+
		// 		'<node label="标签1" add="true" delete="true" open="打开" show="label1" id="1" >'+
		// 			'<node label="标签1-1" add="true" delete="true" open="打开" show="label11" id="11">'+
		// 					'<node label="标签1-1-1" add="true" delete="true" open="打开" show="label111" id="111">'+
		// 						'<node label="标签1-1-1-1" add="true" delete="true" open="打开" id="1111"></node>'+
		// 						'<node label="标签1-1-1-2" add="true" delete="true" open="打开" id="1112"></node>'+
		// 					'</node>'+
		// 			'</node>'+
		// 			'<node label="标签1-2" add="true" delete="true" open="打开" id="12"></node>'+
		// 			'<node label="标签1-3" add="true" delete="true" open="打开" id="13"></node>'+
		// 		'</node>'+
		// 		'<node label="标签2" add="true" id="2">'+
		// 			'<node label="标签2-1" add="true" id="21" show="label21"></node>'+
		// 		'</node>'+
		// 		'<node label="标签3" add="true" id="3">'+
		// 			'<node label="标签3-1" add="true" id="31"></node>'+
		// 		'</node>'+
		// 	'</node>'
		// var doc = (new DOMParser()).parseFromString(xmlStr,"application/xml");
		// var parentNodes=doc.childNodes[0].childNodes;
		// var pId=0;
		// var zNodes=this.getZNodes(parentNodes,pId);
		// $.fn.zTree.init($(this.treeDiv), setting, zNodes);
		// var zNodes =[
		// 	{ id:1, pId:0, name:"普通的父节点", t:"我很普通，随便点我吧", server:{} open:true},
		// 	{ id:11, pId:1, name:"叶子节点 - 1", t:"我很普通，随便点我吧"},
		// 	{ id:12, pId:1, name:"叶子节点 - 2", t:"我很普通，随便点我吧"},
		// 	{ id:13, pId:1, name:"叶子节点 - 3", t:"我很普通，随便点我吧"},
		// 	{ id:2, pId:0, name:"NB的父节点", t:"点我可以，但是不能点我的子节点，有本事点一个你试试看？", open:true},
		// 	{ id:21, pId:2, name:"叶子节点2 - 1", t:"你哪个单位的？敢随便点我？小心点儿..", click:false},
		// 	{ id:22, pId:2, name:"叶子节点2 - 2", t:"我有老爸罩着呢，点击我的小心点儿..", click:false},
		// 	{ id:23, pId:2, name:"叶子节点2 - 3", t:"好歹我也是个领导，别普通群众就来点击我..", click:false},
		// 	{ id:3, pId:0, name:"郁闷的父节点", t:"别点我，我好害怕...我的子节点随便点吧...", open:true, click:false },
		// 	{ id:31, pId:3, name:"叶子节点3 - 1", t:"唉，随便点我吧"},
		// 	{ id:32, pId:3, name:"叶子节点3 - 2", t:"唉，随便点我吧"},
		// 	{ id:33, pId:3, name:"叶子节点3 - 3", t:"唉，随便点我吧"}
		// ];

		

	}

	onRefresh(task,pluginName,formId,result)
	{
		if(this.props.xml.name == pluginName && this.props.formId == formId)
		{
			result.push(this.props.xml.name);
			this.refresh(task);
		}
	}

	refresh(task)
	{
		console.log(task);
		if(!task.arg)
			return;
		if(task.arg.opr == TreeRefreshArg.SET_DATA)
		{
			var xmlString;var expandDeep = 0; var expandNodeId = "";
			if(typeof(task.arg.arg) == "string")
			{
				xmlString = task.arg.arg;
			}
			else
			{
				xmlString = task.arg.arg.data;
				expandDeep = task.arg.arg.expanddeep;
				expandNodeId = task.arg.arg.expandNodeId?task.arg.arg.expandNodeId:"";
			}
			
			if(expandDeep<=0)
				expandDeep = 1;
			var doc = (new DOMParser()).parseFromString(xmlString,"application/xml");
			var parentNodes=doc.childNodes;
			//var expandDeep=task.arg.arg.expanddeep;
			//TODO_YL 增加 需求 默认哪个节点展开、展开多少级，其他节点不展开
			var pId='0';
			var expandNodePId = this.getexpandNodeForOpen(parentNodes,pId,expandDeep,expandNodeId,0);
			var zNodes=this.getZNodes(parentNodes,pId,expandDeep,expandNodeId,expandNodePId,0);
			if(zNodes)
			{
				for(let i = 0;i<zNodes.length;i++)
				{
					if(zNodes[i].pId == 0)
					{
						this.selectedItem = zNodes[i];
						break;
					}
				}
			}
			var setting = {
				data: 
				{
					key: {
						title:"t"
					},
					simpleData: {
						enable: true
					}
				},
				callback:
				{
					// beforeClick: this.beforeItemClick.bind(this),
					onClick: this.onItemClick.bind(this),
					onDblClick: this.onItemDblClick.bind(this),
					onRightClick: this.onItemRightClick.bind(this),
					onKeyChange:this.onKeyChange.bind(this)
				},
				view: {
	                addDiyDom: this.addDiyDom.bind(this)
	            }
			};
			var zTree = $.fn.zTree.init($(this.treeDiv), setting, zNodes);	
			$.fn.zTreeKeyboardNavigation(zTree, this.pluginTreeContainer);
		}
		else if(task.arg.opr == TreeRefreshArg.SELECT_NODE)
		{
			var selId = task.arg.arg;
			let treeObj = $.fn.zTree.getZTreeObj("treePlugin"+this.props.xml.id);
			let nodes = treeObj.getNodes();
			nodes = treeObj.transformToArray(nodes);
			if (nodes.length>0) 
			{
				let treeNode = treeObj.getNodeByParam("serverId", selId);  
			    if(treeNode)
			    {  
			        treeObj.selectNode(treeNode); 

				    let commandTask = new CommandTask();
					commandTask.cmd = Cmd.FormCmd;
					let tasks = [commandTask];
					let arg = {};
					this.selectedItem = treeNode;
					arg["methodName"] = "pluginTreeNodeChange_" + this.props.xml.name;
					arg["methodArg"] = treeNode.serverId//treeNode.id;
					if(arg["methodArg"] == null)
						arg["methodArg"] = treeNode.name;
					commandTask.arg = arg;
					CommandResolver.resolve(tasks,this.props.control.module); 
			    }
			}
		}
		else if(task.arg.opr == TreeRefreshArg.UPDATE_NODE)
		{
			let treeObj = $.fn.zTree.getZTreeObj("treePlugin"+this.props.xml.id);
			let treeUpdateArg = task.arg.arg;
			let updateNode = treeObj.getNodeByParam("serverId",treeUpdateArg.id,null);
			var doc = (new DOMParser()).parseFromString(treeUpdateArg.data,"application/xml");
			let xmlNode = doc.childNodes[0];

			for(let j =0;j<xmlNode.attributes.length;j++)
			{
				var nodeName=xmlNode.attributes[j].nodeName;
				if(nodeName=='label')
				{
					updateNode['name']=xmlNode.attributes[j].nodeValue;
					updateNode['t']=xmlNode.attributes[j].nodeValue;

				}
				else if(nodeName=='id')
				{
					updateNode['serverId']=xmlNode.attributes[j].nodeValue;
				}
				else
				{
					updateNode['server_'+nodeName]=xmlNode.attributes[j].nodeValue;
				}
			}

			treeObj.updateNode(updateNode,false);

			
		}
		else if(task.arg.opr == TreeRefreshArg.DELETE_NODE)
		{
			let treeObj = $.fn.zTree.getZTreeObj("treePlugin"+this.props.xml.id);
			let deleteId = task.arg.arg;
			let deleteNode = treeObj.getNodeByParam("serverId",deleteId,null);
			treeObj.removeNode(deleteNode,false);
		}
		else if(task.arg.opr == TreeRefreshArg.ADD_NODE)
		{
			let treeObj = $.fn.zTree.getZTreeObj("treePlugin"+this.props.xml.id);
			let treeAddArg = task.arg.arg;
			let parentNode = treeObj.getNodeByParam("serverId",treeAddArg.id,null);

			var doc = (new DOMParser()).parseFromString(treeAddArg.data,"application/xml");
			let xmlNode = doc.childNodes[0];
			let zNode = {pId:parentNode.id};

			for(let j =0;j<xmlNode.attributes.length;j++)
			{
				var nodeName=xmlNode.attributes[j].nodeName;
				if(nodeName=='label')
				{
					zNode['name']=xmlNode.attributes[j].nodeValue;
					zNode['t']=xmlNode.attributes[j].nodeValue;

				}else if(nodeName=='id')
				{
					zNode['serverId']=xmlNode.attributes[j].nodeValue;
				}
				else
				{
					zNode['server_'+nodeName]=xmlNode.attributes[j].nodeValue;
				}
			}
			treeObj.addNodes(parentNode,[zNode]);
		}
	}

	addDiyDom(treeId, treeNode) 
	{
        var spaceWidth = 5;
        var switchObj = $("#" + treeNode.tId + "_switch"),
        icoObj = $("#" + treeNode.tId + "_ico");
        switchObj.remove();
        icoObj.parent().before(switchObj);
        /*var spantxt = $("#" + treeNode.tId + "_span").html();
        if ((spantxt.length*7) > $(this.treeDiv).width()) {
            spantxt = spantxt.substring(0, 17) + "...";
            $("#" + treeNode.tId + "_span").html(spantxt);
        }*/
    }

	getZNodes(parentNodes,pId,expandDeep,expandNodeId,expandNodePId,nowDeep)
	{
		var zNodes=[];
		for(var i=0;i<parentNodes.length;i++){
			var parentNode=parentNodes[i];
			var zNode={};
			/*if(pId==0)
				var id=i+''+1;
			else
				var id=parseInt(pId+''+i);*/
			var id = pId + '_' + i;
			
			zNode['id']=id;
			zNode['pId']=pId;
			for(var j =0;j<parentNode.attributes.length;j++){
				var nodeName=parentNode.attributes[j].nodeName;
				if(nodeName=='label'){
					zNode['name']=parentNode.attributes[j].nodeValue;
					zNode['t']=parentNode.attributes[j].nodeValue;
				}else if (nodeName=='id') {
					zNode['serverId']=parentNode.attributes[j].nodeValue;
				}
				else{
					zNode['server_'+nodeName]=parentNode.attributes[j].nodeValue;
				}
				if(expandNodeId && expandNodePId.startsWith(id)){
					zNode['open']="true";
				}else if(expandNodeId && id.startsWith(expandNodePId) && nowDeep<nowDeep+expandDeep-1){
					zNode['open']="true";
				}else{
					if(expandNodeId){
						zNode['open']="false";
					}else if(nowDeep<expandDeep){
						zNode['open']="true";
					}else{
						zNode['open']="false";
					}
				}
		
			}
			zNodes.push(zNode);
			if(parentNode.childNodes.length>0){
				var zNode=this.getZNodes(parentNode.childNodes,id,expandDeep,expandNodeId,expandNodePId,nowDeep+1);
				zNodes.push.apply(zNodes,zNode)
			}
		}
		pId++;

			return zNodes;
	}

	getexpandNodeForOpen(parentNodes,pId,expandDeep,expandNodeId,nowDeep){
		var ids = "";
		for(var i=0;i<parentNodes.length;i++){
			var parentNode=parentNodes[i];
			var id = pId + '_' + i;
			if(expandNodeId == parentNode.id){
				ids = ids+id;
			}
			if(parentNode.childNodes.length>0){
				var idz = this.getexpandNodeForOpen(parentNode.childNodes,id,expandDeep,expandNodeId,nowDeep+1);
				ids = ids+idz;
			}
		}
		pId++;
		return ids;
	}

	beforeItemClick(treeId, treeNode, clickFlag)
	{

	}

	onKeyChange(treeNode)
	{
		if(!treeNode)return;
		var commandTask = new CommandTask();
		commandTask.cmd = Cmd.FormCmd;
		var tasks = [commandTask];
		var arg = {};
		this.selectedItem = treeNode;
		arg["methodName"] = "pluginTreeNodeChange_" + this.props.xml.name;
		arg["methodArg"] = treeNode.serverId//treeNode.id;
		if(arg["methodArg"] == null)
			arg["methodArg"] = treeNode.name;
		commandTask.arg = arg;
		CommandResolver.resolve(tasks,this.props.control.module);
	}

	onItemClick(event, treeId, treeNode, clickFlag)
	{
		var commandTask = new CommandTask();
		commandTask.cmd = Cmd.FormCmd;
		var tasks = [commandTask];
		var arg = {};
		if(this.selectedItem == treeNode)
		{
			return;
		}
		this.selectedItem = treeNode;
		arg["methodName"] = "pluginTreeNodeChange_" + this.props.xml.name;
		arg["methodArg"] = treeNode.serverId//treeNode.id;
		if(arg["methodArg"] == null)
			arg["methodArg"] = treeNode.name;
		commandTask.arg = arg;
		CommandResolver.resolve(tasks,this.props.control.module);
	}

	onItemDblClick(event, treeId, treeNode)
	{
		var commandTask = new CommandTask();
		commandTask.cmd = Cmd.FormCmd;
		var tasks = [commandTask];
		var arg = {};
		arg["methodName"] = "pluginTreeNodeDoubleClick_" + this.props.xml.name;
		arg["methodArg"] = treeNode.serverId;//treeNode.id;
		if(!arg["methodArg"])
			arg["methodArg"] = treeNode.name;
		commandTask.arg = arg;
		CommandResolver.resolve(tasks,this.props.control.module);
	}

	onItemRightClick(event, treeId, treeNode)
	{
		// <ul class="contextMenuPlugin" style="display: block; z-index: 1000001; left: 118px; top: 50px;">
		// 	<div class="gutterLine"></div>
		// 	<li><a href="#"><span>增加</span></a></li>
		// 	<li><a href="#"><span>删除</span></a></li>
		// 	<li><a href="#"><span>label111</span></a></li>
		// 	<li class="divider"></li>
		// 	<li style="display: none;"><a href="#"><span>复制</span></a></li>
		// 	<li><a href="#"><span>粘贴</span></a></li>
		// </ul>
		
		var treeObj = $.fn.zTree.getZTreeObj(("treePlugin"+this.props.xml.id));
		var treeNode = treeObj.getSelectedNodes()[0];
		var rMenuUl=$('<ul></ul>').addClass('contextMenuPlugin').attr('id','rMenu');
		var rMenuLine=$('<div></div>').addClass('gutterLine');
		var that=this;
		rMenuUl.append(rMenuLine);
		if(treeNode){
			if(treeNode.server_add){
				var rMenuSpan=$('<span></span>').html('增加');
				var rMenuA=$('<a></a>').click(function()
					{
						that.treeNodeAdd(that,event,treeId,treeNode);
						rMenuUl.remove();
					}
				).append(rMenuSpan);
				var rMenuli=$('<li></li>').append(rMenuA);
				rMenuUl.append(rMenuli);
			}
			if(treeNode.server_delete){
				var rMenuSpan=$('<span></span>').html('删除');
				var rMenuA=$('<a></a>').click(function()
					{
						that.treeNodeDelete(that,event,treeId,treeNode);
						rMenuUl.remove();
					}
				).append(rMenuSpan);
				var rMenuli=$('<li></li>').append(rMenuA);
				rMenuUl.append(rMenuli);
			}

			for(var i in treeNode){
				if(i.indexOf('server_menu_')>-1&&i!='server_add'&&i!='server_delete'){
					var functionName=i.substring(12);
					var rMenuSpan=$('<span></span>').html(treeNode[i]);
					var rMenuA=$('<a></a>').click(function()
						{
							that.treeNodeOthor(event,treeId,treeNode,functionName);
							rMenuUl.remove();
						}).append(rMenuSpan);
					var rMenuli=$('<li></li>').append(rMenuA);
					rMenuUl.append(rMenuli);
				}	
			}
			var x=event.clientX+document.body.scrollLeft;
			var y=event.clientY+document.body.scrollTop;
			rMenuUl.css({'position':'absolute','top':y+'px','left':x+'px','display':'block'});
			if(rMenuUl.children().length>1){
				$('body').append(rMenuUl);
				$(document).on("mousedown", function(e) {
					if(rMenuUl.length>0){
						if(!(rMenuUl.is(e.target))&&!(rMenuUl.is(e.target.parentNode))&&!(rMenuUl.is(e.target.parentNode.parentNode))&&!(rMenuUl.is(e.target.parentNode.parentNode.parentNode))){
							$(document).off("mousedown");
							rMenuUl.remove();
						}
					}
				});
			}
			
		}
		
	}

	treeNodeAdd(event, treeId, treeNode)
	{
		console.log('Add');
		var commandTask = new CommandTask();
		commandTask.cmd = Cmd.FormCmd;
		var tasks = [commandTask];
		var arg = {};
		arg["methodName"] = "pluginTreeNodeAdd_" + this.props.xml.name;
		arg["methodArg"] = treeNode.serverId;//treeNode.id;
		if(!arg["methodArg"])
			arg["methodArg"] = treeNode.name;
		commandTask.arg = arg;
		CommandResolver.resolve(tasks,this.props.control.module);
	}

	treeNodeDelete(event, treeId, treeNode)
	{
		console.log('Delete');
		var commandTask = new CommandTask();
		commandTask.cmd = Cmd.FormCmd;
		var tasks = [commandTask];
		var arg = {};
		arg["methodName"] = "pluginTreeNodeDelete_" + this.props.xml.name;
		arg["methodArg"] = treeNode.serverId;//treeNode.id;
		if(!arg["methodArg"])
			arg["methodArg"] = treeNode.name;
		commandTask.arg = arg;
		CommandResolver.resolve(tasks,this.props.control.module);
	}

	treeNodeOthor(event,treeId,treeNode,functionName)
	{
		console.log('Change');
		var commandTask = new CommandTask();
		commandTask.cmd = Cmd.FormCmd;
		var tasks = [commandTask];
		var arg = {};
		arg["methodName"] = "pluginTreeNodeMenu_"+functionName+"_" + this.props.xml.name;
		arg["methodArg"] = treeNode.serverId;//treeNode.id;
		if(!arg["methodArg"])
			arg["methodArg"] = treeNode.name;
		commandTask.arg = arg;
		CommandResolver.resolve(tasks,this.props.control.module);

		
	}

	onMapEditorsHandler(selector,mapEditorValues,moduleInstanceId)
	{
		if(this.props.moduleInstanceId != moduleInstanceId)
			return;
		if(selector!="all" && this.props.xml.name != selector)
			return;
		if(this.selectedItem && this.selectedItem.serverId)
			mapEditorValues[this.props.xml.name] = this.selectedItem.serverId+"";//this.getSelectedMap();
		return;
	}

	getSelectedMap()
	{
		let result = {0:"java.util.Map"};
		for(let key in this.selectedItem)
		{
			if(key == "name")
				result["label"] = this.selectedItem[key];
			else if(key == "serverId")
				result["id"] = this.selectedItem[key];
			else if(key && key.indexOf("server_") == 0)
			{
				let key2 = key.substr(7);
				result[key2] = this.selectedItem[key];
			}
		}
		return result;
	}

	pluginTreeOnFocusHandler(e)
	{
		//$(this.pluginTreeContainer).css("border","solid 1px red");
	}

	pluginTreeOnBlurHandler(e)
	{
		//$(this.pluginTreeContainer).css("border","none");
	}

	onContainerKeyDown(e)
	{
		if(9===e.keyCode)
		{
			e.preventDefault();
			FocusActions.focusChange(this.props.xml,e.shiftKey);
			return;
		}
		if(40 === e.keyCode || 39 === e.keyCode)//向下或向右箭头
		{
			/*var treeObj = $.fn.zTree.getZTreeObj(("treePlugin"+this.props.xml.id));
			var selectedNodes = treeObj.getSelectedNodes();
			if ( selectedNodes && selectedNodes.length )
			{
				treeObj.selectNode( selectedNodes[0] );
				$("#" + selectedNodes[0].tId ).focus();
			}
			else
			{
				//触发Home
				$(this.pluginTreeContainer).trigger({ type : 'keydown', which : 36, keyCode: 36 });
			}*/
			return;
			var treeObj = $.fn.zTree.getZTreeObj(("treePlugin"+this.props.xml.id));
			var nodes = treeObj.getSelectedNodes();
			if(nodes.length == 0)
			{
				var allNodes = treeObj.getNodes();
				var node = allNodes[0];
				treeObj.selectNode(node);
			}
			else
			{

			}
			/*else
			{
				var allNodes = treeObj.getNodes();
				var platArray = treeObj.transformToArray(allNodes);
				var index = platArray.indexOf(nodes[nodes.length-1]);
				var newIndex = index+1;
				if(newIndex < 0)
					newIndex = nodes.length-1;
				if(newIndex == nodes.length)
					newIndex = 0;
				var newNode = platArray[newIndex];
				treeObj.selectNode(newNode);
			}*/
			
		}
		if(38 === e.keyCode)//向上箭头
		{

		}
	}

	render()
	{
		let _style = Object.assign({},this.props.customStyle);//_style.overflow = "auto";
		if(!_style)_style = {};
		if(_style.width && _style.width.indexOf && _style.width.indexOf("px") != -1)
			_style.flexShrink = 0;
		_style.overflow = "auto";
		_style.minWidth='100px';
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";
		return  <div onKeyDown={this.onContainerKeyDown.bind(this)} tabIndex="0" ref={node=>this.pluginTreeContainer=node} onFocus={this.pluginTreeOnFocusHandler.bind(this)} onBlur={this.pluginTreeOnBlurHandler.bind(this)} className="formItemPluginTree" style={_style}>
					<ul style={{width:'100%',height:'100%',overflow:'auto'}} id={"treePlugin"+this.props.xml.id} ref={node => this.treeDiv = node} className="ztree"></ul>
				</div>;
	}

}


// WEBPACK FOOTER //
// ./src/formItem/FormItemPluginTree.js